function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var defaults = {
  // The minimum number of slides to display dots
  minSlideCount: 2
};
export var Dots = /*#__PURE__*/function () {
  function Dots(carousel) {
    _classCallCheck(this, Dots);

    this.carousel = carousel;
    this.$list = null;
    this.events = {
      change: this.onChange.bind(this),
      refresh: this.onRefresh.bind(this)
    };
  }
  /**
   * Build wrapping DOM element containing all dots
   */


  _createClass(Dots, [{
    key: "buildList",
    value: function buildList() {
      var _this = this;

      if (this.carousel.pages.length < this.carousel.option("Dots.minSlideCount")) {
        return;
      }

      var $list = document.createElement("ol");
      $list.classList.add("carousel__dots");
      $list.addEventListener("click", function (e) {
        if (!("page" in e.target.dataset)) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        var page = parseInt(e.target.dataset.page, 10);
        var carousel = _this.carousel;

        if (page === carousel.page) {
          return;
        }

        if (carousel.pages.length < 3 && carousel.option("infinite")) {
          carousel[page == 0 ? "slidePrev" : "slideNext"]();
        } else {
          carousel.slideTo(page);
        }
      });
      this.$list = $list;
      this.carousel.$container.appendChild($list);
      this.carousel.$container.classList.add("has-dots");
      return $list;
    }
    /**
     * Remove wrapping DOM element
     */

  }, {
    key: "removeList",
    value: function removeList() {
      if (this.$list) {
        this.$list.parentNode.removeChild(this.$list);
        this.$list = null;
      }

      this.carousel.$container.classList.remove("has-dots");
    }
    /**
     * Remove existing dots and create fresh ones
     */

  }, {
    key: "rebuildDots",
    value: function rebuildDots() {
      var _this2 = this;

      var $list = this.$list;
      var listExists = !!$list;
      var pagesCount = this.carousel.pages.length;

      if (pagesCount < 2) {
        if (listExists) {
          this.removeList();
        }

        return;
      }

      if (!listExists) {
        $list = this.buildList();
      } // Remove existing dots


      var dotCount = this.$list.children.length;

      if (dotCount > pagesCount) {
        for (var i = pagesCount; i < dotCount; i++) {
          this.$list.removeChild(this.$list.lastChild);
        }

        return;
      } // Create fresh DOM elements (dots) for each page


      var _loop = function _loop(index) {
        var $dot = document.createElement("li");
        $dot.classList.add("carousel__dot");
        $dot.dataset.page = index;
        $dot.setAttribute("role", "button");
        $dot.setAttribute("tabindex", "0");
        $dot.setAttribute("title", _this2.carousel.localize("{{GOTO}}", [["%d", index + 1]]));
        $dot.addEventListener("keydown", function (event) {
          var code = event.code;
          var $el;

          if (code === "Enter" || code === "NumpadEnter") {
            $el = $dot;
          } else if (code === "ArrowRight") {
            $el = $dot.nextSibling;
          } else if (code === "ArrowLeft") {
            $el = $dot.previousSibling;
          }

          $el && $el.click();
        });

        _this2.$list.appendChild($dot);
      };

      for (var index = dotCount; index < pagesCount; index++) {
        _loop(index);
      }

      this.setActiveDot();
    }
    /**
     * Mark active dot by toggling class name
     */

  }, {
    key: "setActiveDot",
    value: function setActiveDot() {
      if (!this.$list) {
        return;
      }

      this.$list.childNodes.forEach(function ($dot) {
        $dot.classList.remove("is-selected");
      });
      var $activeDot = this.$list.childNodes[this.carousel.page];

      if ($activeDot) {
        $activeDot.classList.add("is-selected");
      }
    }
    /**
     * Process carousel `change` event
     */

  }, {
    key: "onChange",
    value: function onChange() {
      this.setActiveDot();
    }
    /**
     * Process carousel `refresh` event
     */

  }, {
    key: "onRefresh",
    value: function onRefresh() {
      this.rebuildDots();
    }
  }, {
    key: "attach",
    value: function attach() {
      this.carousel.on(this.events);
    }
  }, {
    key: "detach",
    value: function detach() {
      this.removeList();
      this.carousel.off(this.events);
      this.carousel = null;
    }
  }]);

  return Dots;
}();